export const orange = '#fa7005'
export const gray = "#4a4a4a"
export const slight = "#fafafa"
export const vague = "#ebebeb"